'use client';
import { configureStore } from '@reduxjs/toolkit';
import reducers from './reducers/combine-all.reducers';
import { setCookie } from '@/utils';

export const store = configureStore({
  reducer: reducers,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

store.subscribe(() => {
  const state = store.getState();
  const locationState = state.location;

  if (locationState) {
    setCookie('user_location', JSON.stringify(locationState), 365);
  }
});